import { takeLeading, put, all, call, select } from 'redux-saga/effects';

import axios from 'axios';
import { selectCurrentUser } from '../user/user.selector';
import {
  getNewHireEditorDataSuccess,
  getNewHireEditorDataFailure,
  setNewHireEditorDepartments,
} from './new-hire-ref.actions';
// import { selectCurrentUser } from '../user/user.selector';

import NewHireEditorActionTypes from './new-hire-ref.types';

export function* getNewHireData() {
  try {
    // const user = yield select(selectCurrentUser);
    // const userAuth = yield select(selectCurrentUser);
    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/newhire/data',
      method: 'get',
    });

    if (response.data.status === 'success') {
      yield put(getNewHireEditorDataSuccess(response.data.data));
      yield put(setNewHireEditorDepartments(response.data.data.departments));
    } else {
      alert('Error getting New Hire Data ');
    }
  } catch (error) {
    alert('Error on server while getting New Hire Data');
    yield put(getNewHireEditorDataFailure(error));
  }
}

export function* onGetNewHireData() {
  yield takeLeading(
    NewHireEditorActionTypes.GET_NEW_HIRE_EDITOR_DATA_START,
    getNewHireData
  );
}

export function* newHireEditorSagas() {
  yield all([call(onGetNewHireData)]);
}
